import React from "react";
import Skill from "./skill";
import { useSelector } from "react-redux";

const SkillsList = () => {
  const { userSkills } = useSelector((state) => state.user);

  return (
    <React.Fragment>
      {userSkills?.map((skill, index) => (
        <Skill skill={skill} key={index} index={index} />
      ))}
    </React.Fragment>
  );
};

export default SkillsList;
